import { useCallback, useMemo, useState } from "react";

import { OperationFactory, TSubject, TSubjectOperation } from "./Context";

export type TEditor<T extends TSubject> = {
  current: TSubjectOperation<T> | null;
  start: (r?: T) => void;
  complete: () => void;
};

export const useEditor = <T extends TSubject>(): TEditor<T> => {
  const [operation, setOperation] = useState<TSubjectOperation<T> | null>(null);
  const start = useCallback((r?: T) => {
    if (r) {
      setOperation(OperationFactory.edit(r));
    } else {
      setOperation(OperationFactory.create());
    }
  }, []);
  const complete = useCallback(() => setOperation(null), []);

  return useMemo(
    () => ({
      current: operation,
      start,
      complete,
    }),
    [operation, start, complete]
  );
};
